import React from 'react';
import AppV3 from "./v3/AppV3";

function AppFeatureFlag() {
  return <AppV3 />;
}

export default AppFeatureFlag;
